export const EmployeeRouting = [
  {
    path: "/organization/employee/list",
    name: "basic-organization-employee-list",
    meta: { title: "员工资料" },
    component: () =>
      import(
        /* webpackChunkName: "basic-organization-employee" */ "@/views/organization/employee/list/index.vue"
      ),
  },
];
